import React from 'react';
import './Counter.css';
import { useIntersectionObserver, useCountUp } from '../hooks';

interface CounterItemProps {
  icon: string;
  end: number;
  label: string;
  enabled: boolean;
}

const CounterItem: React.FC<CounterItemProps> = ({ icon, end, label, enabled }) => {
  const count = useCountUp({
    end,
    duration: 2000,
    enabled,
  });

  return (
    <div className="counter-card">
      <div className="counter-icon">
        <i className={icon}></i>
      </div>
      <div className="counter-number">{count}</div>
      <div className="counter-label">{label}</div>
    </div>
  );
};

const Counter: React.FC = () => {
  const { ref, hasIntersected } = useIntersectionObserver({
    threshold: 0.3,
    triggerOnce: true,
  });

  const counterData = [
    { icon: 'fas fa-chalkboard-teacher', end: 15, label: 'Deneyimli Öğretmen' },
    { icon: 'fas fa-child', end: 570, label: 'Mutlu Öğrenci' },
    { icon: 'fas fa-book', end: 500, label: 'Etkinlik' },
    { icon: 'fas fa-smile', end: 180, label: 'Memnun Veli' },
  ];

  return (
    <section className="counter-section">
      {/* Top Wave */}
      <div className="counter-wave-top">
        <svg viewBox="0 0 1440 100" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M0,50 C120,20 240,80 360,50 C480,20 600,80 720,50 C840,20 960,80 1080,50 C1200,20 1320,80 1440,50 L1440,0 L0,0 Z"
                fill="white" />
        </svg>
      </div>

      <h2 className="counter-title sr-only">Rakamlarla Cennetin Çocukları</h2>
      <div
        className="counter-container"
        ref={ref as React.RefObject<HTMLDivElement>}
      >
        {counterData.map((item, index) => (
          <CounterItem
            key={index}
            icon={item.icon}
            end={item.end}
            label={item.label}
            enabled={hasIntersected}
          />
        ))}
      </div>

      {/* Bottom Wave */}
      <div className="counter-wave-bottom">
        <svg viewBox="0 0 1440 100" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M0,50 C120,80 240,20 360,50 C480,80 600,20 720,50 C840,80 960,20 1080,50 C1200,80 1320,20 1440,50 L1440,100 L0,100 Z"
                fill="white" />
        </svg>
      </div>
    </section>
  );
};

export default Counter;
